import { getConfigValue } from '../config/runtimeConfig';

const siteConfig = {
  siteBaseUrl: getConfigValue('REACT_APP_SITE_BASE_URL', process.env.REACT_APP_SITE_BASE_URL, 'https://teliviit.com'),
  supportEmail: getConfigValue('REACT_APP_SUPPORT_EMAIL', process.env.REACT_APP_SUPPORT_EMAIL, 'support@teliviit.com'),
  contactPhone: getConfigValue('REACT_APP_CONTACT_PHONE', process.env.REACT_APP_CONTACT_PHONE, '(984)-374-4238'),
  contactAddress:
    getConfigValue('REACT_APP_CONTACT_ADDRESS', process.env.REACT_APP_CONTACT_ADDRESS, '2500 Regency Parkway, Cary NC 27518'),
  footerPhone: getConfigValue('REACT_APP_FOOTER_PHONE', process.env.REACT_APP_FOOTER_PHONE, '(984) 683-4747'),
  mapEmbedUrl:
    getConfigValue(
      'REACT_APP_MAP_EMBED_URL',
      process.env.REACT_APP_MAP_EMBED_URL,
      'https://maps.google.com/maps?q=2500%20Regency%20Parkway%2C%20Cary%20NC%2027518&t=m&z=10&output=embed&iwloc=near'
    ),
};

export default siteConfig;
